import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { Btn, Field, Input } from "../components/kit";
import { Logo } from "./Landing";

function Shell({ title, children }) {
  return (
    <div className="min-h-screen grid place-items-center bg-[#0B192C] px-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md space-y-5">
        <Logo />
        <h1 className="font-heading text-2xl font-bold text-[#0B192C]">{title}</h1>
        {children}
        <Link to="/login" data-testid="back-to-login" className="block text-sm text-[#FF6500] font-semibold">Voltar ao login</Link>
      </div>
    </div>
  );
}

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      setMsg((await api.post("/auth/forgot-password", { email })).data.message);
    } catch (x) {
      setErr(errMsg(x));
    }
    setBusy(false);
  };
  return (
    <Shell title="Esqueci minha senha">
      {msg ? <p className="text-sm text-emerald-700 bg-emerald-50 rounded-lg p-3" data-testid="forgot-success">{msg}</p> : (
        <form onSubmit={submit} className="space-y-4">
          <p className="text-sm text-slate-600">Informe o e-mail de acesso. Enviaremos um link para você criar uma nova senha.</p>
          <Field label="E-mail"><Input data-testid="forgot-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          {err && <p className="text-sm text-red-600" data-testid="forgot-error">{err}</p>}
          <Btn data-testid="forgot-submit-button" className="w-full py-2.5" disabled={busy}>{busy ? "Enviando…" : "Enviar link"}</Btn>
        </form>
      )}
    </Shell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ p1: "", p2: "" });
  const [err, setErr] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const token = params.get("token") || "";
  const submit = async (e) => {
    e.preventDefault();
    if (f.p1.length < 8) return setErr("A senha deve ter pelo menos 8 caracteres.");
    if (f.p1 !== f.p2) return setErr("As senhas não conferem.");
    setBusy(true);
    setErr(null);
    try {
      await api.post("/auth/reset-password", { token, new_password: f.p1 });
      setDone(true);
      setTimeout(() => nav("/login"), 2500);
    } catch (x) {
      setErr(errMsg(x));
    }
    setBusy(false);
  };
  if (!token) return <Shell title="Link inválido"><p className="text-sm text-slate-600">Solicite um novo link em <Link to="/esqueci-senha" className="text-[#FF6500] font-semibold">Esqueci minha senha</Link>.</p></Shell>;
  return (
    <Shell title="Criar nova senha">
      {done ? <p className="text-sm text-emerald-700 bg-emerald-50 rounded-lg p-3" data-testid="reset-success">Senha alterada! Redirecionando para o login…</p> : (
        <form onSubmit={submit} className="space-y-4">
          <Field label="Nova senha (mín. 8 caracteres)"><Input data-testid="reset-password-input" type="password" value={f.p1} onChange={(e) => setF({ ...f, p1: e.target.value })} /></Field>
          <Field label="Repita a nova senha"><Input data-testid="reset-password-confirm-input" type="password" value={f.p2} onChange={(e) => setF({ ...f, p2: e.target.value })} /></Field>
          {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
          <Btn data-testid="reset-submit-button" className="w-full py-2.5" disabled={busy}>{busy ? "Salvando…" : "Salvar nova senha"}</Btn>
        </form>
      )}
    </Shell>
  );
}
